"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDueDate = parseDueDate;
exports.toDateKey = toDateKey;
function toDateKey(date) {
    return "".concat(date.getFullYear(), "-").concat(date.getMonth(), "-").concat(date.getDate());
}
function parseDueDate(dueDate) {
    var parsed = new Date(dueDate);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}
